module.exports = __webpack_public_path__ + "img/4.6d9484d6.png";